import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { BrandButton } from './BrandButton';
export function Hero() {
  return <section id="top" className="relative overflow-hidden border-b border-white/5 bg-ink-900" data-id="element-103" data-mp="9k0ep7vr8fpn">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-104" data-mp="4mrt0xbedtjn" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28 lg:py-32" data-id="element-105" data-mp="sde1gppbdfu6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-106" data-mp="neawf59c39m7">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-107" data-mp="384jtl03lnltg">
            Viridia Analytics | Real Estate
          </p>
          <h1 className="mt-6 font-display text-4xl font-bold leading-[1.06] tracking-tight text-white sm:text-5xl lg:text-[3.75rem]" data-id="element-108" data-mp="3o7vj9hzbpjw8">
            Your team already pays for the tools. I make them produce.
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-109" data-mp="3e84mtar7cuti">
            Missed calls answered live. Written leads worked in under 60 seconds. Booked on
            your agents&rsquo; calendars, written back to your CRM.
          </p>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6" data-id="element-110" data-mp="2qkdc2blb8puc">
            <BrandButton label="Book your free Response Audit" size="lg" withArrow className="w-full sm:w-auto" data-id="element-111" data-mp="2vievwyqk8t6v" />
            <Link to="/why" className="rounded text-sm font-medium text-white/70 underline decoration-white/25 underline-offset-4 transition-colors hover:text-brand hover:decoration-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-112" data-mp="2lkqw3ue3kvhu">
              See how it works
            </Link>
          </div>

          <p className="mt-6 inline-flex rounded-lg border border-brand/30 bg-brand/10 px-4 py-2 text-sm font-semibold text-brand" data-id="element-113" data-mp="ichyn3y7og42">
            Built for teams doing 50+ sides a year.
          </p>

          <p className="mt-6 flex max-w-xl items-start gap-2 text-sm leading-relaxed text-white/45" data-id="element-114" data-mp="1b04bz3x8qz44">
            <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-115" data-mp="162lz52g3rzqu" />
            Works with Follow Up Boss, kvCORE, Sierra, and the CRM you already run. Flat
            monthly fee. No per-minute meters.
          </p>
        </motion.div>
      </div>
    </section>;
}